import React, { useState } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { Container, Stack, TextField } from "@mui/material";
import TitleValue from "../../../components/title-value";
import ButtonUI from "../../../components/button/buttons";
import { useCreateBlacklistCardMutation } from "../../../service/userCard/useBlackListCard";

export const schema = z.object({
  holder_name: z.string().min(5, "Mínimo 20 caracteres"),
  card_number: z
    .string()
    .length(16, "El número debe tener exactamente 16 dígitos")
    .regex(/^\d+$/, "Solo se permiten números"),

  email: z.string().email("Correo inválido"),
});

type FormData = z.infer<typeof schema>;

interface FormProps {
  handleCloseModal?: any;
  onFinished?: (payload: {
    success: boolean;
    message: string;
    severity?: "success" | "error" | "info" | "warning";
  }) => void;
}

export const FormBlackListCard: React.FC<FormProps> = ({
  onFinished,
  handleCloseModal,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormData>({
    resolver: zodResolver(schema),
  });

  const [createBlacklistCard, { isLoading }] = useCreateBlacklistCardMutation();

  const onSubmit = async (data: FormData) => {
    console.log(data);
    try {
      const res = await createBlacklistCard(data).unwrap();
      if (onFinished) onFinished({ success: true, message: 'Tarjeta blqueada', severity: 'success' });
    } catch (err: any) {
      const message =
        err?.data?.message || err?.error || "Error al bloquear la tarjeta";
    }
  };

  return (
    <Container fixed maxWidth="xs">
      <TitleValue title="Bloquear tarjeta" value="" />

      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="holder_name"
          control={control}
          render={({ field }) => (
            <TextField
              fullWidth
              margin="normal"
              {...field}
              label="Nombre de tarjeta"
              error={!!errors.holder_name}
              helperText={errors.holder_name?.message}
            />
          )}
        />
        <Controller
          name="email"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Correo electronico"
              fullWidth
              margin="normal"
              error={!!errors.email}
              helperText={errors.email?.message}
            />
          )}
        />
        <Controller
          name="card_number"
          control={control}
          render={({ field }) => (
            <TextField
              fullWidth
              margin="normal"
              {...field}
              label="Numero de tarjeta"
              error={!!errors.card_number}
              helperText={errors.card_number?.message}
            />
          )}
        />

        <Stack
          direction="row"
          justifyContent="space-evenly"
          alignItems="center"
        >
          <ButtonUI
            title="Regresar"
            onClick={handleCloseModal}
          />
          <ButtonUI
            type="submit"
            title="Bloquear tarjeta"
            color="primary"
            disabled={isLoading}
          />
        </Stack>
      </form>
    </Container>
  );
};
